import React from "react";
import { isA, getStrValue } from "../../store/utility";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import {
  Button,
  Modal,
  FormGroup,
  Col,
  FormControl,
  InputGroup,
  Form,
  ControlLabel,
} from "react-bootstrap";

import * as UIConstants from "../../components/UI/UIConstants";

export default class UserModal extends React.Component {
  constructor(props) {
    super(props);
    var idLocale = require("moment/locale/fr");
    moment.locale("id", idLocale);

    this.state = {
      actionType: null,
    };
  }

  inputChangeHandler = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };

  updateUser = (event) => {
    event.preventRequest();
  };

  validateForm = () => {
    return false;
  };
  render() {
    const myUser = this.props.data;

    if (null === myUser) return null;
    return (
      <Modal {...this.props} bsSize="large">
        <Modal.Header closeButton>
          <Modal.Title>
            <span>Édition utilisateur {myUser.username}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form horizontal>
            <FormGroup>
              <Col componentClass={ControlLabel} sm={2}>
                Titre
              </Col>
              <Col sm={2}>
                <FormControl
                  componentClass="select"
                  id="title"
                  value={myUser.title === null ? "" : myUser.title}
                  onChange={(event) => this.inputChangeHandler(event)}
                >
                  {UIConstants.USER_TITLE.map((title) => {
                    return (
                      <option key={title.name} value={title.name}>
                        {title.value}
                      </option>
                    );
                  })}
                  ;
                </FormControl>
              </Col>
              <Col componentClass={ControlLabel} sm={2}>
                Actif
              </Col>
              <Col sm={4}>
                <label className="switch">
                  {myUser.activated ? (
                    <input id="activated" type="checkbox" defaultChecked />
                  ) : (
                    <input id="activated" type="checkbox" />
                  )}
                  <em></em>
                </label>
              </Col>
            </FormGroup>
            <FormGroup>
              <Col componentClass={ControlLabel} sm={2}>
                Prénom
              </Col>
              <Col sm={4}>
                <FormControl
                  type="text"
                  id="forname"
                  className="form-control"
                  value={getStrValue(myUser.forname)}
                  placeholder="Prénom"
                />
              </Col>
              <Col componentClass={ControlLabel} sm={2}>
                Nom
              </Col>
              <Col sm={4}>
                <FormControl
                  type="text"
                  id="name"
                  className="form-control"
                  value={getStrValue(myUser.name)}
                  placeholder="Nom"
                />
              </Col>
            </FormGroup>
            {isA() ? (
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>
                  Société
                </Col>
                <Col sm={4}>
                  <FormControl
                    type="text"
                    className="form-control"
                    value={getStrValue(myUser.company)}
                    placeholder="Société"
                  />
                </Col>
              </FormGroup>
            ) : (
              ""
            )}
            <FormGroup>
              <Col componentClass={ControlLabel} sm={2}>
                Email
              </Col>
              <Col sm={10}>
                <InputGroup>
                  <InputGroup.Addon>@</InputGroup.Addon>
                  <FormControl
                    type="text"
                    className="form-control"
                    value={getStrValue(myUser.email)}
                    placeholder="Adresse électronique"
                  />
                </InputGroup>
              </Col>
            </FormGroup>
            <FormGroup>
              <Col sm={2}>&nbsp;</Col>
              <Col lg={5}>
                <InputGroup>
                  <InputGroup.Addon>
                    <span className="fa fa-phone"></span>
                  </InputGroup.Addon>
                  <FormControl
                    type="text"
                    className="form-control"
                    value={getStrValue(myUser.phone)}
                    placeholder="Téléphone fixe"
                  />
                </InputGroup>
              </Col>
              <Col lg={5}>
                <InputGroup>
                  <InputGroup.Addon>
                    <span className="fa fa-mobile-phone"></span>
                  </InputGroup.Addon>
                  <FormControl
                    type="text"
                    className="form-control"
                    value={getStrValue(myUser.cellular)}
                    placeholder="Téléphone portable"
                  />
                </InputGroup>
              </Col>
            </FormGroup>
            <Button
              type="submit"
              disabled={!this.validateForm}
              className="btn btn-block btn-primary mt-lg"
            >
              <span className="fa fa-user"></span>&nbsp;Mettre-à-jour
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Modal/UserModal.js